import React, { useState } from 'react';
import './EventTypePicker.css';
import { EVENT_TYPE_ICONS, EVENT_TYPES } from './eventTypeIcons'; // Import both icons and types
// Map event type to icon (simple emoji for now, can be replaced with SVGs)


export default function EventTypePicker({ eventType, onPick }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="event-type-picker" /* style removed */>
      <button
        type="button"
        className="event-type-picker-btn"
        aria-label="Pick event type"
        onClick={e => { e.stopPropagation(); setOpen(o => !o); }}
        /* style removed */
      >
        {EVENT_TYPE_ICONS[eventType] || '❓'}
      </button>
      {open && (
        <div className="event-type-picker-dropdown">
          {EVENT_TYPES.map(type => (
            <div
              key={type}
              className={`event-type-picker-option${type === eventType ? ' selected' : ''}`}
              onClick={e => { e.stopPropagation(); setOpen(false); onPick(type); }}
            >
              <span className="event-type-picker-icon">{EVENT_TYPE_ICONS[type]}</span>
              <span className="event-type-picker-label">{type}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
